import FormattedMessage from 'I18n/components/FormattedMessage';
import EmptyPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/EmptyPropertyValue';
import { STATUS } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import StatusTagComponent from 'framework-asset-preview-lib/internal/properties/components/propertyValues/StatusTagComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StatusPropertyValue({
  useComponent,
  value
}) {
  switch (value) {
    default:
      return /*#__PURE__*/_jsx(EmptyPropertyValue, {}, "empty");
    case STATUS.ARCHIVED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: 'default',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.archived"
        })
      });
    case STATUS.COMPLETED:
    case STATUS.DONE:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: 'published',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.completed"
        })
      });
    case STATUS.DEFAULT:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.default"
        })
      });
    case STATUS.DELETED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "disabled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.deleted"
        })
      });
    case STATUS.ACTIVE:
    case STATUS.ENABLED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "success",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.active"
        })
      });
    case STATUS.ERROR_ARCHIVE:
    case STATUS.ERROR_FATAL:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "cancelled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.error"
        })
      });
    case STATUS.CANCELED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "cancelled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.canceled"
        })
      });
    case STATUS.DRAFT:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "draft",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.draft"
        })
      });
    case STATUS.FLAGGED_FOR_REVIEW:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.FLAGGED_FOR_REVIEW"
        })
      });
    case STATUS.SECURITY_VIOLATION:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.SECURITY_VIOLATION"
        })
      });
    case STATUS.ONGOING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "thunderdome",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.ongoing"
        })
      });
    case STATUS.IN_PROGRESS:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "thunderdome",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.in_progress"
        })
      });
    case STATUS.PAST:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.past"
        })
      });
    case STATUS.PAUSED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.paused"
        })
      });
    case STATUS.PUBLISHED:
    case STATUS.PUBLISHED_OR_SCHEDULED:
    case STATUS.SUCCESS:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "published",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.published"
        })
      });
    case STATUS.RESCHEDULED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.rescheduled"
        })
      });
    case STATUS.SCHEDULED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.scheduled"
        })
      });
    case STATUS.PLANNED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.planned"
        })
      });
    case STATUS.BUSY:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.busy"
        })
      });
    case STATUS.CONNECTING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.connecting"
        })
      });
    case STATUS.FAILED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.failed"
        })
      });
    case STATUS.MISSED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.missed"
        })
      });
    case STATUS.NO_ANSWER:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.no_answer"
        })
      });
    case STATUS.NO_SHOW:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.no_show"
        })
      });
    case STATUS.RINGING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.ringing"
        })
      });
    case STATUS.HOLD:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.hold"
        })
      });
    case STATUS.CALLING_CRM_USER:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.calling_crm_user"
        })
      });
    case STATUS.QUEUED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.queued"
        })
      });
    case STATUS.SENT:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "published",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.sent"
        })
      });
    case STATUS.TODO:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.todo"
        })
      });
    case STATUS.TURNED_ON:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "active",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.turnedOn"
        })
      });
    case STATUS.TURNED_OFF:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "disabled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.turnedOff"
        })
      });
    case STATUS.UPCOMING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "active",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.upcoming"
        })
      });
    case STATUS.UPLOADED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "info",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.uploaded"
        })
      });
    case STATUS.PENDING_REVIEW:
    case STATUS.WAITING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "scheduled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.pending"
        })
      });
    case STATUS.PROCESSING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "thunderdome",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.processing"
        })
      });
    case STATUS.PRE_PROCESSING:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "thunderdome",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.preProcessing"
        })
      });
    case STATUS.AUTOMATED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "active",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.automated"
        })
      });
    case STATUS.AUTOMATED_DRAFT:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "draft",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.AUTOMATED_DRAFT"
        })
      });
    case STATUS.DEFERRED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "paused",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.deferred"
        })
      });
    case STATUS.NOT_STARTED:
      return /*#__PURE__*/_jsx(StatusTagComponent, {
        useComponent: useComponent,
        use: "paused",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkAssetPreviewLib.propertyValue.shared.status.not_started"
        })
      });
  }
}